import SDGTargetsPanel from './SDGTargetsPanel';

export default SDGTargetsPanel;
